import { CalendarDots, ArrowRight, UserCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Img } from "@/components/ui/img";
import { formatDateTimeBs } from "@/lib/format";
import type { MatchingRecommendationView } from "./types";

interface Props {
  recommendation: MatchingRecommendationView;
  token: string;
}

export function RecommendationCard({ recommendation, token }: Props) {
  const therapist = recommendation.therapist;
  const profileKey = therapist.slug ?? therapist.id;
  const bookingHref = `/therapists/${profileKey}?book=1&match=${encodeURIComponent(token)}`;

  return (
    <article className="rounded-xl border bg-card p-4 shadow-sm">
      <div className="flex gap-4">
        <div className="grid size-16 shrink-0 place-items-center overflow-hidden rounded-xl bg-muted">
          {therapist.profileImageUrl ? (
            <Img src={therapist.profileImageUrl} alt={therapist.userName} sizes="64px" className="size-full object-cover" />
          ) : (
            <UserCircle className="size-9 text-muted-foreground" />
          )}
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="truncate text-lg font-semibold text-foreground" style={{ fontFamily: "var(--font-heading)" }}>
            {therapist.userName}
          </h2>
          <p className="mt-1 text-sm text-muted-foreground">
            {therapist.yearsExperience} god. iskustva
            {therapist.avgRating ? ` · ${therapist.avgRating.toFixed(1)} ocjena` : ""}
          </p>
          <div className="mt-3 flex items-center gap-2 text-sm text-muted-foreground">
            <CalendarDots className="size-4 text-primary" />
            {formatDateTimeBs(recommendation.nextAvailableSlot.scheduledAt)}
          </div>
        </div>
      </div>

      <ul className="mt-4 flex flex-col gap-2">
        {recommendation.reasons.map((reason) => (
          <li key={reason} className="rounded-lg bg-muted/40 px-3 py-2 text-sm text-foreground">
            {reason}
          </li>
        ))}
      </ul>

      <div className="mt-4 flex flex-wrap gap-2">
        <Button asChild>
          <a href={bookingHref}>
            Rezerviši termin
            <ArrowRight className="size-4" />
          </a>
        </Button>
        <Button variant="outline" asChild>
          <a href={`/therapists/${profileKey}`}>Pogledaj profil</a>
        </Button>
      </div>
    </article>
  );
}
